import React, { useEffect, useState } from 'react';
import { ConfigContext } from '../context';
import { validateConfig } from '../utils';
const defaultUseHandleConfigError = ()=>{
    return undefined;
};
const ConfigJSONProvider = ({ children, defaultConfig, configUrl = '/config.json', loader = 'loading', postProcessor, useHandleConfigError = defaultUseHandleConfigError, shouldValidate = true })=>{
    const [data, setData] = useState(defaultConfig);
    const handleConfigError = useHandleConfigError();
    useEffect(()=>{
        if (!data?.initialized) {
            fetch(configUrl, {
                cache: 'no-store'
            }).then(async (response)=>{
                if (response.ok) {
                    return response;
                } else {
                    const text = await response.text();
                    return Promise.reject(`status: ${response.status} (${response.statusText}), url: ${response.url}, body: ${text}`);
                }
            }).then((res)=>res.json()).then((resJson)=>{
                setData((config = {})=>{
                    const newConfig = {
                        ...config,
                        ...resJson,
                        initialized: true
                    };
                    shouldValidate && validateConfig(newConfig);
                    return postProcessor ? postProcessor(newConfig) : newConfig;
                });
            }).catch((error)=>{
                handleConfigError?.(error);
            });
        }
    }, [
        shouldValidate,
        configUrl,
        data?.initialized,
        handleConfigError,
        postProcessor
    ]);
    return /*#__PURE__*/ React.createElement(ConfigContext.Provider, {
        value: data
    }, data?.initialized ? children : loader);
};
export default ConfigJSONProvider;
